<template>
  <div class="wrapper">
    <div class="page page1">
      <h1>{{contract.vendor}}&nbsp;&nbsp;&nbsp;&nbsp;貸款委託代辦契約書</h1>
      <div class="topTit">
        茲委託人：
        <img class="underline" v-if="contract.signature_url
        && contract.signature_url !== ''" style="vertical-align: middle;"
             :src="contract.signature_url" width="80px" height="30px"/>
        <span v-else class="name">{{contract.username}}</span>(以上簡稱甲方)委託

        <span class="underline">
        {{contract.vendor}}
      </span>(以上簡稱乙方)代辦貸款方案，經雙方協議本誠信原則同意立此契約，並共同遵守下列條款：
      </div>
      <ul class="list">

        <li>
          <span class="tit">一.</span>
          甲方須無條件配合乙方一切申辦過程中所需準備之相關資料提供，並保證提供乙方之資料無虛偽及偽造不實，若有偽造不實情事，經乙方查證屬實，致使乙方蒙受信譽及法律之重大之損失，乙方得以保留法律追訴之權利並通知相關刑事單位協助辦理調查，甲方不得有任何異議。
        </li>
        <li>
          <span class="tit">二.</span>
          甲方所提供之資料，乙方於資料收取後需盡妥善保管之責，不得對外及使用於非貸款之用途上，乙方不得有異。<br/>
          簽立本合約時，乙方需詳盡告知甲方貸款之相關事宜，雙方簽立本契約書後，甲方同意遵守契約事項，乙方亦須照程序進行貸款之辦理。
        </li>
        <li>
          <span class="tit">三.</span>
          甲方需確實填寫乙方交付之相關文件，以利申辦過程之順利，如有填寫不實導致申辦案件遭審查退件，甲方不得異議。因案件審核條件不同，所需時間視甲方條件資料而定，甲方不得以委辦時間過久另尋他方辦理。
        </li>
        <li>
          <span class="tit">四.</span>
          乙方於收取所有甲方之貸款相關文件後亦須盡力協助辦理，但如因甲方條件導致審查未能核准貸款，甲方亦不得異議。
        </li>
        <li>
          <span class="tit">五.</span>
          案件完成後，甲方同意支付乙方代辦服務費為核准金額的<span class="percent">{{contract.bonus}}</span>%為酬，並於撥款後，當日將勞務費匯進乙方指定之公司帳戶，甲方不得假借任何名義拖延，如甲方於三日內未能履約，乙方有權依勞務費用加上違約金之金額，向法院聲請裁定，甲方不得有議。
        </li>
        <li>
          <span class="tit">六.</span>
          於貸款送件前，乙方須明確告知甲方貸款所需之各項規定：一、銀行扣款方式。二、利息。三、撥款時扣除之費用。甲方於簽訂合約時亦代表均已了解貸款之相關規定，並同意交由乙方全權辦理，甲方不得再將其個人資料交由其他人辦理，並於乙方協議辦理核准後，甲方均須無條件配合後續安排之對保事宜，甲方不得假借任何名義拖延或拒不對保，如有此情事甲方無條件同意支付該契約之<span class="underline">違約金新台幣三萬元整</span>，以支付乙方之勞務費用。
        </li>
        <li>
          <span class="tit">七.</span>
          上述之條約，經甲、乙雙方同意並簽約後，始為正式契約，甲、乙雙方均須共同遵守條約內容雙方不得有異，並同意以台灣高雄地方法院為第一管轄地院。
        </li>
      </ul>
      <ul class="sign">
        <li>甲&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方：<img v-if="contract.signature_url
        && contract.signature_url !== ''" style="vertical-align: middle;"
                                                              :src="contract.signature_url" width="80px" height="30px"/>
          <v-btn v-else class="primary" dark text v-loading="saveLoading"
                     @click="save">點我簽名</v-btn></li>
        <li>身分證字號：{{contract.memberId}}</li>
        <li>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：{{contract.address}}</li>
        <li>電&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;話：{{contract.cellphone}}</li>
      </ul>
      <ul class="sign">
        <li>乙&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方： {{contract.vendor}}</li>
        <li>身分證字號：</li>
        <li>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</li>
        <li>電&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;話：</li>
      </ul>
      <div class="date">
        中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d"></span>年<span class="d"></span>月<span class="d"></span>日
      </div>

    </div><!--page1-->
    <v-dialog
      fullscreen hide-overlay
      v-model="signDialog.visible">
      <v-card>
        <v-card-text>
          <draw-canvas :visible="true" @handleDownloadSign="handleDownloadSign"  @closeEvent="handleDownloadClose"></draw-canvas>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--提示-->
    <alert-view :visible="dialogVisible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :showCancel="true"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel">
    </alert-view>

  </div><!--wrapper-->
</template>

<script>
  import DrawCanvas from '@/components/DrawCanvas';
  import { mapActions, mapGetters } from 'vuex';
  import UploadView from '@/components/UploadView';
  import AlertView from '@/components/AlertView';

  export default {
    name: 'AgentContract',
    components: { DrawCanvas, AlertView },
    data(){
      return {
        dialogVisible: false,
        contract: {
          signature_url:'',
        },
        saveLoading: false,
        signDialog: {
          title: '',
          text: '',
          visible: false,
          confirm: () => {
          },
          cancel: () => {
          },
        },
        messageDialog: {
          title: '',
          text: '',
          visible: false,
          showCancel: false,
          confirm: () => {
          },
          cancel: () => {
          },
        },
      }
    },
    created() {
      // this.contract.vendorName = this.$route.query.vendorName;
      // this.contract.memberName = this.$route.query.memberName;
      // this.contract.memberId = this.$route.query.memberId;
      this.loadData();
    },
    methods:{
      ...mapActions(['getContractInfo','uploadImageData','updateContractInfo']),
      async loadData(){
        const contractId = this.$route.query.contractId;
        const res = await this.getContractInfo({contractId});
        if (res){
          const result = res.data;
          if (result.statusCode === 0){
            this.contract = result.data;
          } else {
            this.showMessageDialog('錯誤', result.message, true, ()=>{},()=>{});
          }
        }
      },
      async save(){
        this.signDialog.visible = true;
      },
      async handleDownloadSign(image) {
        console.log(`handleDownloadSign == ${image}`);

        let yes = confirm('確認簽名是否正確？');

        if (yes) {
          const name = new Date().getTime();
          const result = await this.uploadImageData({
            name: `contract/${name}.jpg`,
            image: image,
          });
          console.log(`upload result == ${JSON.stringify(result)}`);
          this.contract.signature_url = result;

          await this.updateContractInfo(this.contract);
          this.signDialog.visible = false;
        } else {
          this.signDialog.visible = false;
        }

        //this.showMessageDialog('提示','確認簽名是否正確？', true, async ()=>{

          // this.signDialog.visible = false;
          // this.messageDialog.visible = false;
        //}, ()=>{
          // this.signDialog.visible = false;
          // this.messageDialog.visible = false;
        //});
      },
      handleDownloadClose() {
        this.signDialog.visible = false
      },
      showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
        this.messageDialog.title = title;
        this.messageDialog.text = text;
        this.messageDialog.visible = visible;
        this.dialogVisible = true;
        const self = this;
        this.messageDialog.confirm = () => {
          // self.messageDialog.visible = false;
          if (confirmEvent) {
            confirmEvent();
          }
        };

        this.messageDialog.cancel = () => {
          // self.messageDialog.visible = false;
          if (cancelEvent) {
            cancelEvent();
          }
        };
      },

    }
  };
</script>

<style scoped src="../../assets/css/agent_contract.css">

</style>



// WEBPACK FOOTER //
// src/pages/web/AgentContract.vue